import ClientSlider from "./ClientSlider"
export default ClientSlider
